import FavoriteCardSkeleton from './FavoriteCardSkeleton'

const FavoritesLoadingSkeleton = () => {
  return (
    <div className="favorites-skeleton">
      {/* Скелетон главной категории */}
      <div className="favorites-main-group">
        <div className="skeleton-category-header">
          <div className="skeleton-text skeleton-main-category"></div>
          <div className="skeleton-text skeleton-count"></div>
        </div>

        {/* Скелетон подкатегории */}
        <div className="favorites-subsub-group">
          <div className="skeleton-category-header">
            <div className="skeleton-text skeleton-sub-category"></div>
            <div className="skeleton-text skeleton-count"></div>
          </div>

          {/* Скелетон сетки карточек */}
          <div className="favorites-grid">
            {[...Array(2)].map((_, index) => (
              <FavoriteCardSkeleton key={index} />
            ))}
          </div>
        </div>

        {/* Еще одна подкатегория */}
      </div>
    </div>
  )
}

export default FavoritesLoadingSkeleton
